module.exports = __webpack_public_path__ + "img/shutterstock_367286867.0e0cbae2.png";